import {
  createSystem,
  defaultConfig,
  defineConfig,
  defineTextStyles,
} from "@chakra-ui/react";

const textStyles = defineTextStyles({
  body: {
    value: {
      fontFamily: "Inter",
    },
  },
});

export const appConfig = defineConfig({
  theme: {
    breakpoints: {
      sm: "480px",
      md: "768px",
      lg: "1024px",
      xl: "1272px",
      "2xl": "1536px",
    },
    textStyles,
  },
});

export const theme = createSystem(defaultConfig, appConfig);
